import Banner from "../Banner";
import Footer from "../Footer";
import Header from "../Header";

// ─── Layout ───────────────────────────────────────────────────────────────────
function Layout({ children }: { children?: React.ReactNode }) { 

  return (
    <div className="max-w-page w-full mx-auto">
      <Header />
      <Banner />
      {children}
      <section className="w-full h-[394px] lg:h-fit bg-brand py-[60px] px-[20px] text-center">
        <h2 className="text-white font-bold text-[36px] lg:text-[38px] max-w-[80%] mx-auto">
          HÌNH THÀNH TRI THỨC - DẪN LỐI THỜI ĐẠI SỐ
        </h2>
        <p className="text-white max-w-[90%] mx-auto mt-[20px] text-[20px]">
          Trung Tâm Tri Thức Số - Nơi ươm mầm tài năng, chắp cánh ước mơ
        </p>
      </section>

      <Footer />
    </div>
  );
}

export default Layout;